import { useEffect, useState } from "react";
import { PlusCircle, Pencil, Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { SidebarContext } from "../../shared/context/SidebarContext";
import { useContext } from "react";
import api from "../../shared/services/api";
import {toast} from "react-toastify";

export default function FluxosIndex() {
  const { isOpen } = useContext(SidebarContext);
  const [fluxos, setFluxos] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    carregarFluxos();
  }, []);

  const carregarFluxos = async () => {
    try {
      const res = await api.get("/fluxos");
      setFluxos(res.data);
    } catch {
      toast.error("Erro ao carregar fluxos");
    }
  };

  const excluirFluxo = async (id) => {
    try {
      await api.delete(`/fluxos/${id}`);
      toast.success("Fluxo excluído");
      carregarFluxos();
    } catch {
      toast.error("Erro ao excluir fluxo");
    }
  };

  return (
    <div className="min-h-screen bg-surface-1 text-white flex">
      <div className={`transition-all duration-300 ${isOpen ? 'ml-16 lg:ml-64' : 'ml-16'} w-full p-6`}>
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold">Meus Fluxos</h1>
          <button
            onClick={() => navigate("/fluxos/criar")}
            className="bg-brand-600 hover:bg-brand-700 px-4 py-2 rounded flex items-center gap-2"
          >
            <PlusCircle className="w-5 h-5" /> Criar Fluxo
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {fluxos.map(fluxo => (
            <div key={fluxo.id} className="bg-surface-2 border border-white/[0.08] p-4 rounded-xl">
              <div className="text-lg font-bold mb-2">{fluxo.nome}</div>
              <div className="text-sm text-ink-3 mb-4">Criado em: {new Date(fluxo.criado_em).toLocaleDateString()}</div>
              <div className="flex gap-2">
                <button
                  onClick={() => navigate(`/fluxos/${fluxo.id}`)}
                  className="flex-1 bg-blue-600 hover:bg-blue-700 px-3 py-1 rounded text-sm flex items-center justify-center gap-1"
                >
                  <Pencil className="w-4 h-4" /> Editar
                </button>
                <button
                  onClick={() => excluirFluxo(fluxo.id)}
                  className="flex-1 bg-red-600 hover:bg-red-700 px-3 py-1 rounded text-sm flex items-center justify-center gap-1"
                >
                  <Trash2 className="w-4 h-4" /> Excluir
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
